/**
* reducers for the transaction
*
* Created by Tom on 19/06/18
*/
import moment from 'moment'

import C from '../constants'

const initState = {
    loading: false,
    startDate:moment().subtract(3, 'months'), // date of f months before now
    endDate: moment(), // date of now
    fetchSuccess: true,
    data: [],
    closingBalance: 0
}

export const transactionState = (state = initState, action) => {

    switch(action.type) {

        // in case of `Loading` change
        case C.SET_TRANSACTION_LOADER:
            return {
                ...state,
                loading: action.payload
            }

        // in case of `StartDate` change
        case C.SET_TRANSACTION_START_DATE:
            return {
                ...state,
                startDate: action.payload
            }

        // in case of `EndDate` change
        case C.SET_TRANSACTION_END_DATE:
            return {
                ...state,
                endDate: action.payload
            }

        // in case of `FetchSuccess` change
        case C.SET_TRANSACTION_FETCH_SUCCESS:
            return {
                ...state,
                fetchSuccess: action.payload
            }

        // in case of `Data` change
        case C.SET_TRANSACTION_DATA:
            return {
                ...state,
                data: action.payload
            }

        // in case of `ClosingBalance` change
        case C.SET_TRANSACTION_CLOSING_BALANCE:
            return {
                ...state,
                closingBalance: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/transactionReducers.js